/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/button-has-type */
import React from "react";
import PropTypes from "prop-types";
import { Modal, Box } from "@material-ui/core";
// import CloseIcon from '@mui/icons-material/Close';
import CloseIcon from "@material-ui/icons/Close";
import styles from "./WarningModal.module.css";

const WarningModal = ({
 handleClose,
  open,
  confirmDelete,
  msg,
  popUpHeading,concurrentCross
}) => (
  <Modal open={open}>
    <div className={styles.container}>
      <div className={styles.title}>
        {concurrentCross ? "":
         <span>
         <CloseIcon style={{float:'right'}} fontSize="1rem" onClick={handleClose} />
       </span>
        }
        <span className={styles.txt}>
          {popUpHeading ? popUpHeading : "Delete"}
        </span>
      </div>
      <Box bgcolor="#dadada3d" marginTop="13px" height="75px" marginLeft="9px">
        <p className={styles.warningText}dangerouslySetInnerHTML={{ __html: msg }}/>
      </Box>
      <div className={styles.bottomRow}>
        <button
          onClick={() => {
            // handleClose();
            confirmDelete();
          }}
          className={styles.submitBt}
        >
          OK
        </button>
        {/* <span>
						<button
								onClick={() => {
									handleClose();
									confirmDelete();
						
							}}
							className={styles.submitBt}
						>
							OK
						</button>
					</span> */}
        {/* <button className={styles.cancelBt} onClick={handleClose}>
						Cancel
					</button> */}
      </div>
    </div>
  </Modal>
);

WarningModal.propTypes = {
  confirmDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
//   handleClose: PropTypes.func.isRequired,
  msg: PropTypes.string,
  popUpHeading: PropTypes.string,
};

export default WarningModal;
